export default {
    /* GET_ORDERS
    ---------------------------------------------------------------
    */
    GET_ORDERS_REQUEST: state => {
        state.ordersLoading = true
    },
    GET_ORDERS_SUCCESS: (state, data) => {
        state.orders = data.results
        state.ordersLoading = false
    },
    GET_ORDERS_FAILURE: state => {
        state.ordersLoading = false
    },

    GET_COOPERANT_DELIVERY_STATUS_NAMES_SUCCESS: (state, data) => {
        state.cooperantDeliveryStatusNames = data.results
    },

    SET_ORDERS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    UPDATE_PRODUCT_LIST: (state, product) => {
        state.productsList.push(product)
    },
    UPDATE_COMMENT_LIST: (state, comment) => {
        state.commentsList.push(comment)
    },
    CLEAR_PRODUCT_LIST: state => {
        state.productsList = []
    },
    CLEAR_COMMENT_LIST: state => {
        state.commentsList = []
    },
    CLEAR_ORDERS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}